//请自行添加语言资源
const routeTrack = {
  obnExtId: '客户订单号',
  tmsSystemNumber: 'TMS系统单号',
  carrierNo: '承运商编号',
  carrierName: '承运商名称',
  shipperCode: '货主编码',
  customerCode: '客户编码',
  projectCode: '项目编码',
  province: '省份',
  city: '城市',
  currentStatus: '当前状态',
  operateTime: '操作时间',
  recipient: '签收人',
  operatorPhone: '操作人电话',
  orderStatus: '订单状态',
  routeId: '路由唯一ID',
  routeType: '路由分类',
  routeDescribe: '路由描述',
  routeSimpleDescribe: '路由简易描述',
  routeTime: '路由服务端接受时间',
  pushParam: '推送参数',
  pushTime: '推送时间',
  pushStatus: '推送状态',
  pushCount: '推送次数',
  pushResult: '推送结果',
  createTime: '创建时间',
  creator: '创建者',
  updateTime: '更新时间',
  updater: '修改者',
};
export default routeTrack




// WEBPACK FOOTER //
// ./src/page/transit/routeTrack/lang/routeTrack.zh.js